module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    ref: "missionAccessModal",
    attrs: {
      "id": "missionAccessModal",
      "size": "lg",
      "title": _vm.$t('mission.modal.access'),
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.setMissionAccesses
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-12 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('mission.access.existing')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-12"
  }, [_c('mission-accesses', {
    attrs: {
      "missionAccesses": _vm.missionAccesses
    }
  })], 1)]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-12 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('mission.access.add')))]), _vm._v(" "), _c('div', {
    staticClass: "col col-12",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('mission.access.add.explanation'))
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.addMissionAccess($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.access.community.selection'),
      "state": _vm.missionAccessAddCommunityState,
      "description": _vm.$t('mission.access.community.selection.description')
    }
  }, [_c('typeahead', {
    ref: "missionAccessAddCommunityTypeahead",
    attrs: {
      "action": "searchCommunities",
      "actionIndicator": "searchingCommunities",
      "onHit": _vm.permissionCommunitySelected
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.access.user.selection'),
      "state": _vm.missionAccessAddUserState,
      "description": _vm.$t('mission.access.user.selection.description')
    }
  }, [_c('typeahead', {
    ref: "missionAccessAddUserTypeahead",
    attrs: {
      "action": "searchUsers",
      "actionIndicator": "searchingUsers",
      "onHit": _vm.permissionUserSelected
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.addMissionAccess
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.add.mission.access')) + "\n                ")])], 1)])])], 1)])]), _vm._v(" "), _c('div', {
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "Mission access actions"
    }
  }, [_c('b-btn', {
    on: {
      "click": _vm.hideMissionAccessModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.close')) + "\n        ")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47c7ace2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/modals/MissionAccessModal.vue
// module id = 512
// module chunks = 0